import { useEffect, useRef, useState } from "react";

import ThreadCard from "./threadcard";
import ThreadHeader from "./threadheader";
import NewThreadModal from "./newthreadmodal";
import { useDispatch, useSelector } from "react-redux";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import api from "../../../../api/api";
import dayjs from "dayjs";
// import {  leftarrow, rightarrow } from "../../../../colorcoding/svg/iconsvg";
import DateRangeSelector from "../../../../daterangepicker/DateRangeSelector";
import calendericon from "../../../../assets/patientcharts/calendericon.svg";
import { getPracticeId } from "../../../../config/practice";
const filtericon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#6B7280"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

const CATEGORIES = [
  "Urgent",
  "Labs",
  "Callback",
  "Rx Refill",
  "Administrative",
  "Insurance",
  "Referral",
];

const Threads = ({ data }) => {
  console.log("CurrData", data);

  const [search, setSearch] = useState("");
  const [expandedId, setExpandedId] = useState(0); // default open
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [statusCounts, setStatusCounts] = useState({
    Open: 0,
    Closed: 0,
    Resolved: 0,
    Pending: 0,
    "In Progress": 0,
  });
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(dayjs().subtract(9, "day"));
  const [endDate, setEndDate] = useState(dayjs());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [threadsData, setThreadsData] = useState([]);
  const practiseid = getPracticeId();

  const [users, setUsers] = useState([]);
  const calendarRef = useRef(null);
  const [showCategoryFilter, setShowCategoryFilter] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [appliedCategories, setAppliedCategories] = useState([]);
  const filterRef = useRef(null);
  const formatThreads = (data = []) => {
    // 1. Sort by date DESC
    const sorted = [...data].sort(
      (a, b) => dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf(),
    );

    // 2. Map for quick lookup
    const map = {};
    sorted.forEach((item) => {
      map[item.id] = { ...item, replies: [] };
    });

    const result = [];

    // 3. Build parent-child structure
    sorted.forEach((item) => {
      if (item.non_visit_note_id && map[item.non_visit_note_id]) {
        // ✅ child → push into parent
        map[item.non_visit_note_id].replies.push(map[item.id]);
      } else {
        // ✅ parent → push to result
        result.push(map[item.id]);
      }
    });

    // 🔥 4. IMPORTANT: Add parent as first reply
    result.forEach((parent) => {
      parent.replies = [
        {
          ...parent,
          isParent: true,
        },
        ...parent.replies.map((r) => ({
          ...r,
          isParent: false,
        })),
      ];
    });

    return result;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowCategoryFilter(false);
        setSelectedCategories(appliedCategories);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [appliedCategories]);

  const fetchUsersData = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/users`); // Fetch users for the specific practice ID
      if (response.status === 200) {
        setUsers(response.data); // Set the user data
      } else {
        setUsers([]); // Clear users if response isn't successful
      }
    } catch (error) {
      console.error(
        "Error fetching users:",
        error.response || error.message || error,
      );
      setUsers([]); // Clear users in case of error
    } finally {
    }
  };

  const getThreads = async ({ skipLoader = false, start, end, status } = {}) => {
    try {
      if (!skipLoader) setLoading(true);

      const effectiveStart = start || startDate;
      const effectiveEnd = end || endDate;
      const effectiveStatus = status !== undefined ? status : activeTab;

      const params = {
        startdate: dayjs(effectiveStart).format("YYYY-MM-DD"),
        enddate: dayjs(effectiveEnd).format("YYYY-MM-DD"),
      };

      // Include status param if a status filter is active
      if (effectiveStatus) {
        params.isstatus = effectiveStatus;
      }

      setStatusCounts({
        Open: 0,
        Closed: 0,
        Resolved: 0,
        Pending: 0,
        "In Progress": 0,
      });

      const response = await api.get(
        `/v1/${practiseid}/nonvisitnotes?patientid=${data?.patientid}`,
        { params },
      );

      if (response.status === 200) {
        setThreadsData(formatThreads(response.data || []));
        if (response.status_counts) {
          setStatusCounts(response.status_counts);
        }
      } else {
        setThreadsData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (status) => {
    if (activeTab === status) {
      // Click same tab again → deselect, fetch with date only
      setActiveTab("");
      getThreads({ status: "" });
    } else {
      setActiveTab(status);
      getThreads({ status });
    }
  };

  const filteredThreads = threadsData.filter((thread) => {
    const matchesSearch = thread?.subject
      ?.toLowerCase()
      .includes(search.toLowerCase());
    const matchesCategory =
      appliedCategories.length === 0 ||
      appliedCategories.some((cat) =>
        thread?.category?.toLowerCase().includes(cat.toLowerCase()),
      );
    return matchesSearch && matchesCategory;
  });
  useEffect(() => {
    getThreads({});
    fetchUsersData();
  }, []);
  const handleRangeSubmit = () => {
    setIsCalendarOpen(false);
    getThreads({ skipLoader: false, start: startDate, end: endDate });
  };

  const handleRangeReset = () => {
    const defaultStart = dayjs().subtract(9, "day");
    const defaultEnd = dayjs();
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setIsCalendarOpen(false);
    getThreads({ start: defaultStart, end: defaultEnd });
  };

  const handleClearDate = () => {
    const defaultStart = dayjs().subtract(9, "day");
    const defaultEnd = dayjs();
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    getThreads({ start: defaultStart, end: defaultEnd });
  };

  const handleClearStatus = () => {
    setActiveTab("");
    getThreads({ status: "" });
  };

  const handlePrevDate = () => {
    const newStart = startDate.subtract(1, "day");
    const newEnd = endDate.subtract(1, "day");
    setStartDate(newStart);
    setEndDate(newEnd);
    getThreads({ skipLoader: false, start: newStart, end: newEnd });
  };

  const handleNextDate = () => {
    const newStart = startDate.add(1, "day");
    const newEnd = endDate.add(1, "day");
    setStartDate(newStart);
    setEndDate(newEnd);
    getThreads({ skipLoader: false, start: newStart, end: newEnd });
  };

  const isDefaultRange =
    startDate.isSame(dayjs().subtract(9, "day"), "day") &&
    endDate.isSame(dayjs(), "day");
  return (
    <>
      <div className="px-4 min-h-[70vh] flex flex-col gap-3">
        <ThreadHeader
          onNewThread={() => setOpenModal(true)}
          thread={threadsData}
          search={search}
          loading={loading}
          setSearch={setSearch}
          filteredThreads={filteredThreads}
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          statusCounts={statusCounts}
          isDefaultRange={isDefaultRange}
          startDate={startDate}
          endDate={endDate}
          onClearDate={handleClearDate}
          onClearStatus={handleClearStatus}
          appliedCategories={appliedCategories}
          onClearCategory={(cat) => {
            setAppliedCategories((prev) => prev.filter((c) => c !== cat));
            setSelectedCategories((prev) => prev.filter((c) => c !== cat));
          }}
          onClearAllCategories={() => {
            setAppliedCategories([]);
            setSelectedCategories([]);
          }}
          datePicker={
            <div className="relative flex items-center gap-2 bg-white rounded-[10px] px-3 py-2 border border-gray-100 shadow-sm">
              <div className="flex flex-col items-center">
                <span className="text-[10px] text-[#3A3A49] font-medium">
                  {isDefaultRange ? "Last 10 Days" : startDate.isSame(endDate, "day") ? startDate.format("dddd") : "Custom Range"}
                </span>
                <Typography
                  variant="h6"
                  sx={{ fontSize: "13px", color: "#3A3A49" }}
                >
                  {startDate.isSame(endDate, "day")
                    ? startDate.format("MM.DD.YYYY")
                    : `${startDate.format("MM.DD")} - ${endDate.format("MM.DD.YYYY")}`}
                </Typography>
              </div>
              <img
                onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                className="cursor-pointer"
                alt="Calendar Icon"
                src={calendericon}
              />
              {isCalendarOpen && (
                <div
                  ref={calendarRef}
                  className="absolute top-[100%] right-0 z-10"
                >
                  <DateRangeSelector
                    selectedDateRange={{
                      startDate: startDate.toDate(),
                      endDate: endDate.toDate(),
                      key: "selection",
                    }}
                    setSelectedDateRange={(range) => {
                      setStartDate(dayjs(range.startDate));
                      setEndDate(dayjs(range.endDate));
                    }}
                    onSubmit={handleRangeSubmit}
                    handlereset={handleRangeReset}
                  />
                </div>
              )}
            </div>
          }
          filterIcon={
            <div className="relative" ref={filterRef}>
              <div
                onClick={() => {
                  setShowCategoryFilter(!showCategoryFilter);
                  setSelectedCategories(appliedCategories);
                }}
                className={`w-10 h-10 flex items-center justify-center rounded-lg border cursor-pointer hover:bg-gray-50 ${
                  appliedCategories.length > 0
                    ? "border-[#E17954] bg-[#FFF3EF]"
                    : "border-gray-200 bg-white"
                }`}
              >
                {filtericon}
              </div>
              {showCategoryFilter && (
                <div className="absolute top-[110%] right-0 z-50 bg-white border border-gray-200 rounded-2xl shadow-xl py-6 px-7 min-w-[450px]">
                  <h3 className="text-lg font-bold text-[#1E293B] mb-1 text-left">
                    Filter by Category
                  </h3>
                  <p className="text-sm text-gray-400 mb-3 text-left">
                    Select one or more categories to narrow results.
                  </p>
                  <div className="flex flex-col gap-4">
                    {CATEGORIES.map((cat) => {
                      const isChecked = selectedCategories.includes(cat);
                      return (
                        <div
                          key={cat}
                          onClick={() => {
                            setSelectedCategories((prev) =>
                              prev.includes(cat)
                                ? prev.filter((c) => c !== cat)
                                : [...prev, cat],
                            );
                          }}
                          className="flex items-center gap-3 cursor-pointer"
                        >
                          <div
                            className={`w-6 h-6 rounded-md flex items-center justify-center border-2 flex-shrink-0 transition-colors ${
                              isChecked
                                ? "bg-[#E17954] border-[#E17954]"
                                : "border-gray-300 bg-white"
                            }`}
                          >
                            {isChecked && (
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            )}
                          </div>
                          <span className="text-[15px] font-medium text-[#1E293B] whitespace-nowrap">
                            {cat}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-100">
                    <button
                      onClick={() => {
                        setSelectedCategories([]);
                        setAppliedCategories([]);
                        setShowCategoryFilter(false);
                      }}
                      className="text-sm text-gray-500 border border-gray-200 rounded-xl px-5 py-2.5 hover:bg-gray-50 transition-colors"
                    >
                      Clear all
                    </button>
                    <button
                      onClick={() => {
                        setAppliedCategories(selectedCategories);
                        setShowCategoryFilter(false);
                      }}
                      className="text-sm font-medium text-white bg-[#E17954] rounded-xl px-7 py-2.5 hover:opacity-90 transition-opacity"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          }
        />

        <div className=" flex flex-col gap-1 overflow-hidden">
          {filteredThreads.map((thread, index) => (
            <ThreadCard
              key={thread.id}
              index={index}
              users={users}
              fetchdata={getThreads}
              data={data}
              thread={thread}
              resdata={filteredThreads}
              expanded={expandedId === thread.id}
              onToggle={() =>
                setExpandedId(expandedId === thread.id ? null : thread.id)
              }
            />
          ))}
        </div>
        <NewThreadModal
          fetchdata={getThreads}
          data={data}
          open={openModal}
          onClose={() => setOpenModal(false)}
          users={users}
        />
      </div>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Threads;
